import { render } from "./CardPlayer.vue?vue&type=template&id=a2b45e8e"
import script from "./CardPlayer.vue?vue&type=script&lang=js"
export * from "./CardPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/home/desarollo2/Documents/GitHub/dicora-customers-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__